<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="1100px"
      @click:outside="handleClose"
      @keydown="handleEvent"
      scrollable
    >
      <v-card flat>
        <v-toolbar class="v-toolbar__content--custom py-6" flat>
          <v-toolbar-title
            class="header__title--main ml-2"
            :class="{
              'white--text': $vuetify.theme.dark,
            }"
          >
            <v-icon
              :color="$vuetify.theme.dark ? 'white' : 'var(--v-brand-darken2)'"
              @click="handleGoToStart"
              v-if="stage === 'upload' || stage === 'link'"
            >
              mdi-arrow-left
            </v-icon>
            <span class="mb-0" v-if="stage === 'start'">{{
              $t('message.pages.addVideo.videoType')
            }}</span>
            <span class="mb-0 ml-4" v-else-if="stage === 'upload'">{{
              $t('message.importVideos')
            }}</span>
            <span class="mb-0 ml-4" v-else-if="stage === 'link'">{{
              $t('message.pages.addVideo.externalLink')
            }}</span>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-alert
            type="info"
            color="var(--v-brand-lighten1)"
            v-if="stage === 'link'"
            class="external__alert--notice"
            v-html="
              $t('message.pages.addVideo.alertExternalVideo', {
                count: planPlays,
              })
            "
          >
          </v-alert>
          <v-row v-if="stage === 'start'">
            <v-col>
              <CreateVideoOptionCard
                :title="$t('message.pages.addVideo.cards.import.title')"
                :description="
                  $t('message.pages.addVideo.cards.import.description')
                "
                :items="features.import"
                :imgSource="require(`@/assets/video_file.svg`)"
                :actionBtnText="
                  $t('message.pages.addVideo.cards.import.actionBtn')
                "
                :bottomText="
                  $t('message.pages.addVideo.cards.import.bottomTxt')
                "
                @action="handleGoToImport"
              />
            </v-col>
            <v-col>
              <CreateVideoOptionCard
                :title="$t('message.pages.addVideo.cards.external.title')"
                :description="
                  $t('message.pages.addVideo.cards.external.description')
                "
                :items="features.external"
                :imgSource="require(`@/assets/external.svg`)"
                :actionBtnText="
                  $t('message.pages.addVideo.cards.external.actionBtn')
                "
                :bottomText="
                  $t('message.pages.addVideo.cards.external.bottomTxt')
                "
                :isBeta="true"
                @action="handleGoToExternalLink"
              />
            </v-col>
          </v-row>
          <NewImportModal
            v-else-if="stage === 'upload'"
            :uppyConfig="uppyConfig"
          />
          <v-row v-else-if="stage === 'link'">
            <v-form
              ref="externalForm"
              v-model="isExternalFormValid"
              lazy-validation
              style="width: 100%"
            >
              <v-col cols="12" class="pt-5">
                <span
                  class="source-description"
                  :class="{
                    'white--text': $vuetify.theme.dark,
                  }"
                  >{{ $t('message.pages.addVideo.videoSource') }}</span
                >
                <v-row class="mt-2 items-row">
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="require(`@/assets/ytb.svg`)"
                      :isActive="externalSourceOption === 'youtube'"
                      label="Youtube"
                      @onClick="handleChangeExternalSourceOption('youtube')"
                    />
                  </v-col>
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="require(`@/assets/vimeoicon.svg`)"
                      :isActive="externalSourceOption === 'vimeo'"
                      label="Vimeo"
                      @onClick="handleChangeExternalSourceOption('vimeo')"
                    />
                  </v-col>
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="require(`@/assets/s3.svg`)"
                      :isActive="externalSourceOption === 's3'"
                      label="Amazon S3"
                      @onClick="handleChangeExternalSourceOption('s3')"
                    />
                  </v-col>
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="require(`@/assets/wasabi.png`)"
                      :isActive="externalSourceOption === 'wasabiS3'"
                      label="Wasabi S3"
                      @onClick="handleChangeExternalSourceOption('wasabiS3')"
                    />
                  </v-col>
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="require(`@/assets/digitalOceanS3.png`)"
                      :isActive="externalSourceOption === 'digitalOceanS3'"
                      label="Digital Ocean S3"
                      @onClick="
                        handleChangeExternalSourceOption('digitalOceanS3')
                      "
                    />
                  </v-col>
                  <v-col class="py-0">
                    <ExternalVideoSourceCard
                      :imgSrc="
                        $vuetify.theme.dark
                          ? require(`@/assets/link_dark.svg`)
                          : require(`@/assets/link.svg`)
                      "
                      :isActive="externalSourceOption === 'url'"
                      label="Link"
                      @onClick="handleChangeExternalSourceOption('url')"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="items-ipt">
                  <template>
                    <v-col cols="12" class="pb-0">
                      <label
                        class="source-description"
                        :class="{
                          'white--text': $vuetify.theme.dark,
                        }"
                      >
                        {{
                          $t(
                            'message.pages.externalSourceVideo.labels.sourceLink'
                          )
                        }}</label
                      >
                      <v-text-field
                        v-model="externalSourceLink"
                        outlined
                        dense
                        autofocus
                        :placeholder="externalSourceLinkPlaceholder"
                        :rules="requiredFieldRule"
                        :key="externalLinkIptKey"
                      >
                        <template #message="{ message }">
                          <v-icon
                            color="red"
                            size="14"
                            class="iptMessage__error--icon"
                          >
                            mdi-alert-circle
                          </v-icon>
                          <span class="red--text">
                            {{ message }}
                          </span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <template
                      v-if="
                        ['s3', 'wasabiS3', 'digitalOceanS3'].includes(
                          externalSourceOption
                        )
                      "
                    >
                      <v-col cols="12" class="pb-0 pt-0">
                        <label
                          class="source-description"
                          :class="{
                            'white--text': $vuetify.theme.dark,
                          }"
                          >{{
                            $t(
                              'message.pages.externalSourceVideo.labels.s3.akid'
                            )
                          }}</label
                        >
                        <v-text-field
                          v-model="s3AccessKeyID"
                          outlined
                          dense
                          :placeholder="`${$t('message.eg')} ${$t(
                            'message.pages.externalSourceVideo.placeholders.s3.akid'
                          )}`"
                          :rules="requiredFieldRuleId"
                        >
                          <template #message="{ message }">
                            <v-icon
                              color="red"
                              size="14"
                              class="iptMessage__error--icon"
                            >
                              mdi-alert-circle
                            </v-icon>
                            <span class="red--text">
                              {{ message }}
                            </span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0 pt-0">
                        <label
                          class="source-description"
                          :class="{
                            'white--text': $vuetify.theme.dark,
                          }"
                          >{{
                            $t(
                              'message.pages.externalSourceVideo.labels.s3.ski'
                            )
                          }}
                        </label>
                        <v-text-field
                          v-model="s3SecretAccessKey"
                          outlined
                          dense
                          :placeholder="`${$t('message.eg')} ${$t(
                            'message.pages.externalSourceVideo.placeholders.s3.ski'
                          )}`"
                          :rules="requiredFieldRuleId"
                        >
                          <template #message="{ message }">
                            <v-icon
                              color="red"
                              size="14"
                              class="iptMessage__error--icon"
                            >
                              mdi-alert-circle
                            </v-icon>
                            <span class="red--text">
                              {{ message }}
                            </span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </template>
                    <v-col cols="12" v-if="errors.fetchError">
                      <v-row no-gutters align="center">
                        <v-alert dense outlined type="error" width="100%">
                          <span class="footerText align-text d-block">
                            {{ errors.shownErrMsg }}
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="pb-1"
                                  size="18"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-help-circle
                                </v-icon>
                              </template>
                              <v-container
                                class="text-body-2 pa-0"
                                style="max-width: 230px"
                              >
                                {{ errors.tooltipErrMsg }}
                              </v-container>
                            </v-tooltip>
                          </span>
                        </v-alert>
                      </v-row>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
            </v-form>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-6 pb-6" v-if="stage === 'link'">
          <v-spacer></v-spacer>
          <base-btn
            type="primary"
            class="px-10"
            @click="handleConfirmAddExternalSourceVideo"
            :disabled="loading"
            :loading="loading"
          >
            {{ $t('message.pages.addVideo.cards.external.actionBtn') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import NewImportModal from '@/components/NewImportModal.vue'
import CreateVideoOptionCard from '@/components/CreateVideoOptionCard.vue'
import ExternalVideoSourceCard from '@/components/ExternalVideoSourceCard.vue'
import externalSourceVideoApi from '@/services/externalSourceVideoApi.js'
import i18n from '@/translations/lang'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import { mapState } from 'vuex'

export default {
  name: 'CreateVideoModal',
  watch: {
    open(val) {
      if (!val) {
        this.stage = 'start'
      }
    },
  },
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
    uppyConfig: {
      required: true,
      default: {},
    },
    currentFolderId: {
      required: false,
      default: false,
    },
  },
  mixins: [calcMegabytesMixin],
  components: {
    NewImportModal,
    CreateVideoOptionCard,
    ExternalVideoSourceCard,
    BaseBtn,
  },
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    planInfoLimit() {
      if (this.planInfo && this.planInfo?.limit) {
        return this.planInfo.limit
      }
      return {}
    },
    planPlays() {
      // eslint-disable-next-line
      if (!!this.planInfoLimit && this.planInfoLimit?.play_plan) {
        return `${String(this.planInfoLimit.play_plan).slice(0, -3)}k`
      }
      return '5k'
    },
    externalSourceLinkPlaceholder() {
      const options = {
        youtube: 'https://youtu.be/{video_id}',
        s3: 'https://s3.amazonaws.com/{bucket_name}/{key}',
        digitalOceanS3:
          'https://{bucket_name}.{region}.digitaloceanspaces.com/{key}',
        wasabiS3: 'https://s3.{region}.wasabisys.com/{bucket_name}/{key}',
        url: 'https://{domain}/video.mp4',
        vimeo: 'https://player.vimeo.com/{video_id}',
      }
      return `${i18n.t('message.eg')} ${options[this.externalSourceOption]}`
    },
    features() {
      const _this = this
      return {
        import: [
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat1'
            ),
            check: true,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat2'
            ),
            check: true,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat3'
            ),
            check: true,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat4',
              {
                length: _this.getTextTotalStorage(),
              }
            ),
            check: true,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-espaco-de-armazenamento-dos-videos-1gt1eft/',
              en: 'https://help.pandavideo.com/en-us/article/how-does-the-video-storage-space-work-guk6az/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat5',
              {
                length: _this.getTotalTraffic(),
              }
            ),
            check: true,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-consumo-de-banda-dos-videos-ckj2on/',
              en: 'https://help.pandavideo.com/en-us/article/what-is-video-bandwidth-and-how-does-it-work-742s06/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat6'
            ),
            check: true,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-recurso-de-videos-externos-1vel7ty/',
              en: 'https://help.pandavideo.com/en-us/article/how-does-the-external-videos-feature-works-187j22s/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.import.features.feat7'
            ),
            check: true,
          },
        ],
        external: [
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat1'
            ),
            check: false,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat2'
            ),
            check: false,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat3'
            ),
            check: false,
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat4',
              { length: '2' }
            ),
            check: false,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-espaco-de-armazenamento-dos-videos-1gt1eft/',
              en: 'https://help.pandavideo.com/en-us/article/how-does-the-video-storage-space-work-guk6az/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat5'
            ),
            check: false,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-consumo-de-banda-dos-videos-ckj2on/',
              en: 'https://help.pandavideo.com/en-us/article/what-is-video-bandwidth-and-how-does-it-work-742s06/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat6',
              {
                plays: _this.planPlays,
              }
            ),
            check: true,
            article: {
              pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-o-recurso-de-videos-externos-1vel7ty/',
              en: 'https://help.pandavideo.com/en-us/article/how-does-the-external-videos-feature-works-187j22s/',
            },
          },
          {
            text: _this.$i18next.t(
              'message.pages.addVideo.cards.external.features.feat7'
            ),
            check: true,
          },
        ],
      }
    },
  },
  data: () => ({
    externalLinkIptKey: 0,
    loading: false,
    isExternalFormValid: false,
    requiredFieldRule: [],
    requiredFieldRuleId: [],
    externalSourceLink: '',
    s3AccessKeyID: '',
    s3SecretAccessKey: '',
    stage: 'start',
    externalSourceOption: 'youtube',
    stageOptions: ['start', 'upload', 'link'],
    errors: {
      fetchError: false,
      shownErrMsg: 'Error',
      tooltipErrMsg: 'Error',
    },
  }),
  methods: {
    handleChangeExternalSourceOption(option) {
      this.externalSourceOption = option
      this.externalLinkIptKey++
      this.externalSourceLink = this.s3AccessKeyID = this.s3SecretAccessKey = ''
      this.requiredFieldRule = []
      this.requiredFieldRuleId = []
    },
    getTotalTraffic() {
      let trafficVal = null
      if (this.planInfo?.subscription) {
        this.planInfo.subscription.status === 'trialing'
          ? (trafficVal =
              Number(this.planInfo.subscription.metadata.transfer) * 1024)
          : (trafficVal = this.planInfo?.limit?.traffic_plan)
        const totalTraffic = String(
          this.calcMegabytes(trafficVal, 'MB', 'GB', true)
        ).replace(',', '.')
        return totalTraffic
      }
      return ''
    },
    getTextTotalStorage() {
      let textStoragePlan = String(
        this.calcMegabytes(this.planInfo?.limit?.storage_plan, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStoragePlan
    },
    async validateForm() {
      this.requiredFieldRule = [
        (v) => {
          return !!v || i18n.t('message.requiredFieldMessage')
        },
        (v) => {
          return (
            v.includes('https://') ||
            i18n.t('message.pages.video.errors.invalidUrl')
          )
        },
        (v) => {
          if (
            this.externalSourceOption === 'youtube' &&
            !v.includes('youtu.be') &&
            !v.includes('youtube.com')
          ) {
            return i18n.t('message.invalidUrlYtb')
          }
        },
        (v) => {
          if (
            this.externalSourceOption === 'url' &&
            (v.includes('youtu.be') || v.includes('youtube.com'))
          ) {
            return i18n.t('message.invalidExternalUrl')
          }
        },
      ]
      this.requiredFieldRuleId = [this.requiredFieldRule[0]]
      await this.$refs.externalForm.validate()
    },
    async handleConfirmAddExternalSourceVideo() {
      this.clearErrors()
      try {
        await this.validateForm()
        if (!this.isExternalFormValid) return
        this.loading = true
        const pureExternalOption = [
          's3',
          'wasabiS3',
          'digitalOceanS3',
        ].includes(this.externalSourceOption)
          ? 's3'
          : this.externalSourceOption
        const data = await externalSourceVideoApi.createExternalSourceVideo(
          this.externalSourceLink,
          pureExternalOption,
          this.currentFolderId,
          [this.s3AccessKeyID, this.s3SecretAccessKey]
        )
        const videoFormat = {
          title: data.title,
          id: data.id,
          status: data.status,
          folder_id: data.folder_id,
          updated_at: data.updated_at,
          video_external_source_id: data.video_external_source_id,
          video_external_id: data.video_external_id,
          video_source: data.video_source,
          video_url: data.video_url,
        }
        this.$root.$emit('addVideoVideosPage', videoFormat)
        this.handleResetIpts()
        this.$router.push({ name: 'VideoPage', params: { id: data.id } })
        this.handleClose()
        this.loading = false
      } catch (e) {
        this.loading = false
        this.handleFetchError(e)
      }
    },
    handleFetchError(err) {
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.fetchError = true
      this.errors.tooltipErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => {
        if (typeof this.errors[e] === 'string') {
          return (this.errors[e] = '')
        }
        this.errors[e] = false
      })
    },
    handleResetIpts() {
      this.externalSourceLink = ''
      this.s3AccessKeyID = ''
      this.s3SecretAccessKey = ''
      this.externalSourceOption = 'youtube'
    },
    handleGoToStart() {
      this.stage = 'start'
    },
    handleGoToImport() {
      this.stage = 'upload'
    },
    handleGoToExternalLink() {
      this.stage = 'link'
    },
    handleClose() {
      this.$emit('close')
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/header';

::v-deep .external__alert--notice {
  color: var(--v-brand-darken3);
}

::v-deep .external__alert--notice .v-alert__wrapper .v-icon.v-alert__icon {
  align-self: auto !important;
}

::v-deep
  .external__alert--notice
  .v-alert__wrapper
  .v-icon.v-alert__icon::before {
  color: var(--v-brand-darken1);
}

.description-card--text {
  font-size: 16px;
  color: var(--v-neutral-base);
}

.description {
  font-size: 16px;
  color: var(--v-neutral-base);
  font-weight: 400;
}

.v-toolbar__contet--custom {
  align-items: flex-start;
}

.source-description {
  font-weight: 500;
  font-size: 16px;
  color: var(--v-neutral-lighten1);
}

.items-row .col {
  max-width: 144px;
}

.items-ipt {
  min-height: 161.59px;
}

.iptMessage__error--icon {
  margin-top: 2px;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0 24px 24px !important;
}

::v-deep .v-toolbar__content--custom .v-toolbar__content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: unset !important;
}

.v-toolbar__content--custom {
  height: unset !important;
}

::v-deep a.dark-link {
  color: var(--v-primary-darken3);
}
</style>
